import { ServiceApi } from "./Api";
import { loadProgressBar } from 'axios-progress-bar';
import moment from "moment/min/moment-with-locales";
import { ServiceLogin } from "../service/Login";

export class PedidoPortalService {

    listarPortalExamesPaged(FiltroDTO) {
        
        loadProgressBar();

        try{            

            const auth = JSON.parse(sessionStorage.getItem("auth"));

            FiltroDTO.MedicoSolicitanteFiltro = auth.TipoMedico === "0" ? { Id: auth.IdMedico } : null;
    
            FiltroDTO.MedicoExecutanteFiltro = auth.TipoMedico === "1" || auth.TipoMedico === "2" ? { Id: auth.IdMedico } : null;    

            FiltroDTO.TokenPortal = auth.TokenPortal === undefined ? '' : auth.TokenPortal;

            return ServiceApi.post("api/Portal/PostListarPortalExamesPaged", FiltroDTO);

        }catch(error){
            console.log(error);
            return null;
        }

    }

    getLaudo(acessoDTO) {
        loadProgressBar();
        return ServiceApi.post("api/Portal/PostObterIdPrimeiroPedido", acessoDTO); //Para obter o Id do pedido para adicionar histórico de aceite do LGPD
    }

    obterUltimosLaudosComStudyUid(ultimoLaudoFiltro) {
        loadProgressBar();
        return ServiceApi.post("api/Portal/PostUltimosLaudosComStudyUid", ultimoLaudoFiltro)
    }

    /*/
    formatDate(value){
        return moment.utc(moment(value).year()+"-"+(moment(value).month() + 1)+"-"+moment(value).date()).toDate();
    }
    /*/

}